import { Utils } from 'vue-graphql-models';

export default {
  setSidebarStatus({ commit }, { sidebarOpen }) {
    commit('setSidebarStatus', { sidebarOpen });
  },
  watchOnlineOffline({ commit }) {
    window.addEventListener('online', () => {
      commit('setOnline', { online: true });
    });
    window.addEventListener('offline', () => {
      commit('setOnline', { online: false });
    });
  },
  setAuthenticated({ commit }, { authenticated }) {
    commit('setAuthenticated', { authenticated });
  },
  setProfileComplete({ commit }, { profileComplete }) {
    commit('setProfileComplete', { profileComplete });
  },
  async setLoading({ commit }, { loading }) {
    if (!loading) {
      await Utils.sleep();
    }
    commit('setLoading', { loading });
  },
};
